// Framework Yazım Kiti — design review D5: JSON.parse hatasında müşteri-dostu teşhis.
// Saf, platform-agnostic; FE (TransferMenu) kullanır. Sıra: en olası sebepler önce.
export interface JsonParseDiagnosis {
  title: string;
  hints: string[];
}

const BOM = "﻿";
const SMART_QUOTES = /[“”‘’]/;

export function diagnoseJsonParseFailure(text: string): JsonParseDiagnosis {
  const hints: string[] = [];
  const hasBom = text.startsWith(BOM);
  const trimmed = (hasBom ? text.slice(1) : text).trim();

  if (hasBom) {
    hints.push(
      "Dosya görünmez bir BOM işaretiyle başlıyor — Not Defteri'nde 'UTF-8' (BOM'suz) olarak yeniden kaydedin.",
    );
  }
  if (trimmed.startsWith("```")) {
    hints.push(
      "Dosya ``` ile başlıyor — yapay zekanın kod çitini (```json … ```) silin; dosya { ile başlayıp } ile bitmeli.",
    );
  }
  if (SMART_QUOTES.test(text)) {
    hints.push(
      "Akıllı tırnak (“ ” ‘ ’) var — dosya Word/Pages ile kaydedilmiş olabilir. Not Defteri veya TextEdit'te düz metin, UTF-8, .json olarak kaydedin (Playbook Aşama 3).",
    );
  }
  if (!trimmed.endsWith("}")) {
    hints.push(
      "Dosya } ile bitmiyor — yapay zeka çıktısı yarıda kesilmiş olabilir. Playbook'taki DEVAM prompt'unu kullanın ve dosyayı yeniden kaydedin.",
    );
  }
  if (hints.length === 0) {
    hints.push(
      "Sık sebepler: fazladan virgül, eksik tırnak, yorum satırı. Dosyayı yapay zekaya 'bu JSON'u doğrula ve düzelt' diye geri verin (Playbook Aşama 5).",
    );
  }
  return { title: "Geçersiz JSON dosyası", hints };
}
